import { apiClient } from '../api/apiClient';
import { API_ENDPOINTS } from '../api/apiEndpoints';
import type {
  CreatedHrAdmin,
  HrAdminCreateInput,
  ManagedOrganization,
  OrganizationCreateInput,
} from '../types/managedOrganization';

type Envelope<T> = { success: boolean; message: string; data: T };
export type OrganizationPage = {
  items: ManagedOrganization[];
  pagination: { page: number; pageSize: number; totalRecords: number; totalPages: number };
};

export async function listOrganizations(search = ''): Promise<OrganizationPage> {
  const response = await apiClient.get<Envelope<OrganizationPage>>(
    API_ENDPOINTS.ORGANIZATIONS.LIST,
    { params: { search: search.trim() || undefined, page: 1, pageSize: 100 } },
  );
  return response.data.data;
}

export async function createOrganization(
  input: OrganizationCreateInput,
): Promise<ManagedOrganization> {
  const response = await apiClient.post<Envelope<ManagedOrganization>>(
    API_ENDPOINTS.ORGANIZATIONS.CREATE,
    input,
  );
  return response.data.data;
}

export async function getManagedOrganization(
  organizationId: number,
): Promise<ManagedOrganization> {
  const response = await apiClient.get<Envelope<ManagedOrganization>>(
    API_ENDPOINTS.ORGANIZATIONS.DETAILS(organizationId),
  );
  return response.data.data;
}

export async function createOrganizationHrAdmin(
  organizationId: number,
  input: HrAdminCreateInput,
): Promise<CreatedHrAdmin> {
  const response = await apiClient.post<Envelope<CreatedHrAdmin>>(
    API_ENDPOINTS.ORGANIZATIONS.CREATE_HR_ADMIN(organizationId),
    input,
  );
  return response.data.data;
}
